// Currency utility functions
export const getCurrencySymbol = (currency, includeSpace = true) => {
    const currencySymbols = {
        'ZAR': 'R',
        'USD': '$',
        'EUR': '€',
        'GBP': '£',
        'CAD': 'C$',
        'AUD': 'A$',
        'JPY': '¥',
        'CHF': 'CHF',
        'CNY': '¥',
        'INR': '₹'
    };
    
    const symbol = currencySymbols[currency] || '$';
    return includeSpace ? `${symbol} ` : symbol;
};

export const formatPrice = (price, currency, includeSpace = true) => {
    const symbol = getCurrencySymbol(currency, includeSpace);
    return `${symbol}${price}`;
};